import { SysDeptUserFeaturePage } from "..";

/** 组织和用户管理页面。 */
export function SysDeptUserPage() {
  return <SysDeptUserFeaturePage />;
}
